import type { GameState } from '../game/types';
import { clamp } from './math';
import { buildFinancialSnapshot } from './financialSnapshot';

const STARTING_ASSET_BASE = 40_000_000;
const PRIME_ASSET_SCALE = 520_000_000;
const STARTING_REPUTATION = 52;
const PRIME_REPUTATION = 95;

export const BANK_LOAN_TERM_WEEKS = 52;
export const BANK_LOAN_INTEREST_INTERVAL_WEEKS = 4;

export function creditProgress(game: GameState): number {
  const snapshot = buildFinancialSnapshot(game);
  const scaleProgress = clamp((snapshot.totalAssets - STARTING_ASSET_BASE) / (PRIME_ASSET_SCALE - STARTING_ASSET_BASE), 0, 1);
  const reputationProgress = clamp((game.reputation - STARTING_REPUTATION) / (PRIME_REPUTATION - STARTING_REPUTATION), 0, 1);
  return Math.min(scaleProgress, reputationProgress);
}

export function bankLoanAnnualRate(game: GameState): number {
  return 0.2 - creditProgress(game) * 0.12;
}

export function bankLoanCapacity(game: GameState): number {
  return Math.max(0, Math.floor(bankLoanLimit(game) - buildFinancialSnapshot(game).debt));
}

export function bankLoanLimit(game: GameState): number {
  const snapshot = buildFinancialSnapshot(game);
  const advanceRate = 0.18 + creditProgress(game) * 0.22;
  return Math.floor(snapshot.totalAssets * advanceRate);
}

export function bankLoanMonthlyInterest(principal: number, annualRate: number): number {
  return principal * annualRate / 12;
}

export function bankLoanAverageWeeklyInterest(principal: number, annualRate: number): number {
  return bankLoanMonthlyInterest(principal, annualRate) / BANK_LOAN_INTEREST_INTERVAL_WEEKS;
}
